var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeat3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 62,
    viewBox: "0 0 82 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 31C72 13.8792 58.1208 0 41 0C23.8792 0 10 13.8792 10 31C10 48.1208 23.8792 62 41 62C58.1208 62 72 48.1208 72 31Z",
    fill: "url(#paint0_linear_5_244)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6666 13.7793H24.0265C22.4014 13.7793 21.084 15.0761 21.084 16.6758V47.0495C21.084 48.6492 22.4014 49.946 24.0265 49.946H58.6666C60.2917 49.946 61.6091 48.6492 61.6091 47.0495V16.6758C61.6091 15.0761 60.2917 13.7793 58.6666 13.7793Z",
    fill: "#0048B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2614 13.7793H12.9173C11.3061 13.7793 10 15.0885 10 16.7034V47.3663C10 48.9812 11.3061 50.2904 12.9173 50.2904H47.2614C48.8726 50.2904 50.1788 48.9812 50.1788 47.3663V16.7034C50.1788 15.0885 48.8726 13.7793 47.2614 13.7793Z",
    fill: "url(#paint1_linear_5_244)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4759 21.9406C15.4759 21.5608 15.5518 21.1846 15.6992 20.8336C15.8466 20.4827 16.0626 20.1638 16.335 19.8952C16.6073 19.6266 16.9307 19.4135 17.2865 19.2681C17.6424 19.1227 18.0238 19.0479 18.4089 19.0479H44.7024C45.0344 19.0486 45.3638 19.1052 45.6765 19.2152C45.4398 18.7216 45.0656 18.3045 44.5976 18.0128C44.1296 17.721 43.5871 17.5665 43.0334 17.5674H16.7436C15.9657 17.5674 15.2197 17.8722 14.6696 18.4146C14.1196 18.9571 13.8105 19.6929 13.8105 20.4601V43.4309C13.8111 44.0285 13.9991 44.6113 14.3489 45.0992C14.6987 45.5872 15.193 45.9565 15.7641 46.1563C15.5748 45.7672 15.4763 45.3412 15.4759 44.9096V21.9406Z",
    fill: "#0048B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0943 46.5009C43.4795 46.5009 43.8609 46.4252 44.2168 46.2783C44.5726 46.1313 44.8959 45.9159 45.1682 45.6443C45.4405 45.3728 45.6564 45.0504 45.8037 44.6957C45.9509 44.3409 46.0266 43.9607 46.0263 43.5768V20.3719C46.026 19.9363 45.9269 19.5064 45.7364 19.1143C45.4239 19.0032 45.0946 18.946 44.7627 18.9453H18.478C18.0929 18.9453 17.7117 19.0209 17.3559 19.1677C17.0002 19.3146 16.677 19.5299 16.4047 19.8012C16.1324 20.0726 15.9164 20.3947 15.7691 20.7492C15.6217 21.1038 15.5459 21.4838 15.5459 21.8675V45.0725C15.5463 45.5085 15.6448 45.9388 15.834 46.3319C16.1466 46.443 16.4759 46.5001 16.8077 46.5009H43.0943Z",
    fill: "url(#paint2_linear_5_244)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9192 38.2341C33.0755 38.2341 35.6343 35.7667 35.6343 32.723C35.6343 29.6793 33.0755 27.2119 29.9192 27.2119C26.7628 27.2119 24.2041 29.6793 24.2041 32.723C24.2041 35.7667 26.7628 38.2341 29.9192 38.2341Z",
    fill: "#55BC60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7437 37.5448C32.4218 37.5448 34.5929 35.3859 34.5929 32.7226C34.5929 30.0594 32.4218 27.9004 29.7437 27.9004C27.0656 27.9004 24.8945 30.0594 24.8945 32.7226C24.8945 35.3859 27.0656 37.5448 29.7437 37.5448Z",
    fill: "#86CF8D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3973 37.2007C31.8841 37.2007 33.9001 35.1959 33.9001 32.7229C33.9001 30.2499 31.8841 28.2451 29.3973 28.2451C26.9105 28.2451 24.8945 30.2499 24.8945 32.7229C24.8945 35.1959 26.9105 37.2007 29.3973 37.2007Z",
    fill: "#E7F5E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1553 30.4882L29.786 29.875L29.4573 29.3127C29.4513 29.3025 29.4427 29.2941 29.4323 29.2882C29.4219 29.2824 29.4102 29.2793 29.3982 29.2793C29.3863 29.2793 29.3745 29.2824 29.3641 29.2882C29.3538 29.2941 29.3451 29.3025 29.3391 29.3127L29.0086 29.875L28.6485 30.4882C28.0995 30.6635 27.6323 31.0255 27.3307 31.509C27.0292 31.9926 26.9132 32.5659 27.0035 33.126C27.0939 33.686 27.3847 34.196 27.8237 34.5643C28.2626 34.9325 28.821 35.1349 29.3982 35.1349C29.9755 35.1349 30.5338 34.9325 30.9728 34.5643C31.4117 34.196 31.7025 33.686 31.7929 33.126C31.8833 32.5659 31.7672 31.9926 31.4657 31.509C31.1642 31.0255 30.6969 30.6635 30.1479 30.4882H30.1553Z",
    fill: "#318E3A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2578 39.6719L31.4835 40.7453",
    stroke: "#256B2C",
    strokeWidth: 0.688889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6349 39.4688L27.2891 40.5114",
    stroke: "#256B2C",
    strokeWidth: 0.688889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6051 37.4932L23.7842 38.2245",
    stroke: "#256B2C",
    strokeWidth: 0.688889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.974 34.2754L21.8945 34.4999",
    stroke: "#256B2C",
    strokeWidth: 0.688889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1765 30.676L22.1299 30.332",
    stroke: "#256B2C",
    strokeWidth: 0.688889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1622 27.6582L24.4268 26.8418",
    stroke: "#256B2C",
    strokeWidth: 0.688889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4005 26.0353L28.1748 24.9619",
    stroke: "#256B2C",
    strokeWidth: 0.688889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0186 26.2371L32.3626 25.1963",
    stroke: "#256B2C",
    strokeWidth: 0.688889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0537 28.2128L35.8765 27.4814",
    stroke: "#256B2C",
    strokeWidth: 0.688889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6846 31.4305L37.764 31.2061",
    stroke: "#256B2C",
    strokeWidth: 0.688889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4844 35.0322L37.531 35.3743",
    stroke: "#256B2C",
    strokeWidth: 0.688889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4961 38.0479L35.2315 38.866",
    stroke: "#256B2C",
    strokeWidth: 0.688889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3831 27.3956L53.0771 20.1283L55.8065 17.4141L60.2885 21.8712L69.1772 12.4004L71.9992 15.0205L60.3831 27.3956Z",
    fill: "#52B23D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5195 46.9172C56.5206 48.7712 55.8807 50.5692 54.707 52.0097C54.0082 50.2821 52.3212 48.9384 50.1999 48.4394C50.8181 48.0452 51.2911 47.4625 51.5483 46.7785C51.8054 46.0945 51.8328 45.3461 51.6263 44.6454C51.4198 43.9446 50.9905 43.3293 50.4028 42.8915C49.815 42.4537 49.1005 42.2171 48.3662 42.2171C47.6319 42.2171 46.9173 42.4537 46.3296 42.8915C45.7419 43.3293 45.3126 43.9446 45.1061 44.6454C44.8996 45.3461 44.927 46.0945 45.1841 46.7785C45.4412 47.4625 45.9143 48.0452 46.5325 48.4394C44.4092 48.9404 42.7261 50.284 42.0273 52.0097C41.2072 51.0007 40.6425 49.8108 40.3807 48.5398C40.1189 47.2689 40.1676 45.954 40.5227 44.7056C40.8779 43.4572 41.529 42.3119 42.4216 41.3656C43.3141 40.4194 44.4219 39.7 45.652 39.2678C46.8821 38.8356 48.1985 38.7033 49.4907 38.8819C50.7829 39.0605 52.0131 39.5449 53.078 40.2943C54.1429 41.0438 55.0114 42.0364 55.6106 43.1888C56.2098 44.3413 56.5221 45.6199 56.5214 46.9172H56.5195Z",
    fill: "url(#paint3_linear_5_244)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.707 52.0096C53.9435 52.9511 52.9777 53.7107 51.8805 54.2325C50.7833 54.7543 49.5825 55.0252 48.3662 55.0252C47.1499 55.0252 45.9491 54.7543 44.8519 54.2325C43.7547 53.7107 42.7889 52.9511 42.0254 52.0096C42.7241 50.2821 44.4112 48.9384 46.5306 48.4393C45.9118 48.0451 45.4382 47.4621 45.1807 46.7777C44.9232 46.0933 44.8956 45.3444 45.1022 44.6431C45.3087 43.9418 45.7382 43.3259 46.3263 42.8878C46.9144 42.4497 47.6294 42.2129 48.3643 42.2129C49.0991 42.2129 49.8141 42.4497 50.4022 42.8878C50.9903 43.3259 51.4198 43.9418 51.6264 44.6431C51.8329 45.3444 51.8054 46.0933 51.5478 46.7777C51.2903 47.4621 50.8167 48.0451 50.198 48.4393C52.3309 48.9403 54.0083 50.284 54.707 52.0096Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_244",
    x1: 41,
    y1: 0,
    x2: 41,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_244",
    x1: 10,
    y1: 32.0349,
    x2: 50.1788,
    y2: 32.0349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80ADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005AE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_244",
    x1: 15.5459,
    y1: 32.7222,
    x2: 46.0263,
    y2: 32.7222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCDEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_244",
    x1: 40.211,
    y1: 45.4085,
    x2: 56.5195,
    y2: 45.4085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD89F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat3);
export default __webpack_public_path__ + "static/media/feat-3.a7eb8570dd35c8f1b3d296a0ff0b212e.svg";
export { ForwardRef as ReactComponent };